<template>
  <v-card class="mb-4">
    <v-card-title>Totals</v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <site-filter
            store="acquisition"
            :multiple="false"
            :dependsOnSiteGroups="false"
          />
        </v-col>
      </v-row>
      <v-row>
        <!-- Section Viously -->
        <v-col cols="12" md="6">
          <v-card outlined>
            <v-card-title>Viously</v-card-title>
            <v-card-text>
              <div class="text-h6">Daily CA</div>
              <div class="text-h4 font-weight-bold">
                {{ totals.viously.dailyCA }}
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Section Wizystat -->
        <v-col cols="12" md="6">
          <v-card outlined>
            <v-card-title>Wizystat</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="6">
                  <div class="text-h6">Vues</div>
                  <div class="text-h4 font-weight-bold">
                    {{ totals.wizystat.vues }}
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="text-h6">Sessions</div>
                  <div class="text-h4 font-weight-bold">
                    {{ totals.wizystat.sessions }}
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import SiteFilter from "@/components/common/filters/SiteFilter";
import useAxios from "@/hooks/useAxios";
export default {
  name: "Totals",
  components: {
    SiteFilter,
  },
  data() {
    return {
      totals: {
        viously: {
          dailyCA: 0,
        },
        wizystat: {
          vues: 0,
          sessions: 0,
        },
      },
    };
  },
  setup() {
    const { axiosGet, axiosPost, isLoading } = useAxios();

    return {
      axiosGet,
      isLoading,
      axiosPost,
    };
  },
  created() {
    this.fetchTotalsData();
  },
  computed: {
    selectedSite() {
      return this.$store.getters["acquisition/getSites"];
    },
    dateRange() {
      return this.$store.getters["acquisition/getDates"];
    },
  },
  watch: {
    selectedSite() {
      this.fetchTotalsData();
    },
    dateRange() {
      this.fetchTotalsData();
    },
  },
  methods: {
    async fetchTotalsData() {
      try {
        const params = {};
        if (this.selectedSite) {
          params.site_id = this.selectedSite;
        }
        if (this.dateRange && this.dateRange.length === 2) {
          params.date_start = this.dateRange[0];
          params.date_end = this.dateRange[1];
        }
        const { data } = await this.axiosGet(
          "/acquisition/report/partners-totals",
          params
        );
        this.totals = {
          viously: {
            dailyCA: data.viously_computed,
          },
          wizystat: {
            vues: data.views_wysistat,
            sessions: data.visits_wysistat,
          },
        };
      } catch (error) {
        console.error("Error fetching totals data:", error);
      }
    },
  },
};
</script>

<style scoped>
.v-card {
  border-radius: 8px;
}
</style>
